<p-dialog
	[header]="header()"
	[(visible)]="visible"
	[modal]="true"
	[dismissableMask]="true"
	[style]="{ width: '560px', maxHeight: '80vh' }"
	appendTo="body"
	(onHide)="onHide()"
	(onShow)="onShow()"
>
	@if (sourceLabel()) {
		<div class="mb-2 text-[12px] text-wb-muted">
			Copying <span class="font-mono text-wb-text">{{ sourceLabel() }}</span> to:
		</div>
	}

	<div class="mb-3">
		<input
			#searchInput
			pInputText
			class="w-full"
			[placeholder]="searchPlaceholder()"
			[ngModel]="searchQuery()"
			(ngModelChange)="searchQuery.set($event)"
		/>
	</div>

	<div class="copy-list">
		@for (group of filteredGroups(); track $index) {
			<div class="copy-group">
				<div class="copy-group-label">{{ group.label }}</div>

				@if (group.scenes.length > 0) {
					<div class="copy-section-label">Scenes</div>
					@for (scene of group.scenes; track scene.slug) {
						<button
							type="button"
							class="copy-item"
							[class.copy-item--selected]="isSelected('scene', group.chapterSlug, scene.slug)"
							[attr.aria-pressed]="isSelected('scene', group.chapterSlug, scene.slug)"
							(click)="selectTarget('scene', group.chapterSlug, scene.slug)"
						>
							<i class="pi pi-play-circle copy-item-icon"></i>
							<span class="copy-item-slug">{{ scene.slug }}</span>
							@if (isSelected('scene', group.chapterSlug, scene.slug)) {
								<i class="pi pi-check copy-item-check"></i>
							}
						</button>
					}
				}

				@if (group.images.length > 0) {
					<div class="copy-section-label">Images</div>
					@for (image of group.images; track image.slug) {
						<button
							type="button"
							class="copy-item"
							[class.copy-item--selected]="isSelected('image', group.chapterSlug, image.slug)"
							[attr.aria-pressed]="isSelected('image', group.chapterSlug, image.slug)"
							(click)="selectTarget('image', group.chapterSlug, image.slug)"
						>
							<i class="pi pi-image copy-item-icon"></i>
							<span class="copy-item-slug">{{ image.slug }}</span>
							@if (isSelected('image', group.chapterSlug, image.slug)) {
								<i class="pi pi-check copy-item-check"></i>
							}
						</button>
					}
				}
			</div>
		}
		@if (filteredGroups().length === 0) {
			<div class="text-center py-8 text-wb-muted text-sm">No matching destination</div>
		}
	</div>

	<div class="mt-3 flex items-center justify-end gap-2">
		<button pButton size="small" severity="secondary" [text]="true" (click)="cancel()">Cancel</button>
		<button pButton size="small" [disabled]="!selected()" (click)="confirm()"><i class="pi pi-copy"></i>{{ confirmLabel() }}</button>
	</div>
</p-dialog>
